
import React from "react";
import ReactDOM from "react-dom/client";
import {Link, BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import AuthLayout from "./layouts/Auth/Auth.js";
import AdminLayout from "./layouts/Admin/Admin.js";
import RTLLayout from "./layouts/RTL/RTL.js";

import Login from "./views/pages/Login.js";
import CreateModel from "./views/ai/text/CreateModel.js";
import "./assets/css/nucleo-icons.css";
import "react-notification-alert/dist/animate.css";
import "./assets/scss/black-dashboard-pro-react.scss?v=1.2.0";
import "./assets/demo/demo.css";

import {Provider} from "react-redux";
import store from "./store";
import { Notifications } from 'react-push-notification';
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
   <Notifications />
  <BrowserRouter basename="/netxcellservice">
  {/* <div className="company-brand">
    <a href='https://www.netxcell.com/' target="_blank">Powered By Netxcell</a>
  </div> */}
  <Provider store={store} >
    <Switch>
      {/* <Route path="/auth/login" render={(props) => <AuthLayout {...props} />} /> */}
     
      <Route path="/rtl" render={(props) => <RTLLayout {...props} />} />
    
      <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
      <Route path="/auth/login" render={(props) => <Login {...props} />} />
     
      <Redirect from="/" to="/auth/login" />
    </Switch>
    </Provider>
  </BrowserRouter>
  </>
);
